





















import { Component, Mixins, Prop } from 'vue-property-decorator';

import MyForm from '@/mixins/form';

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  userInfo: { [t: string]: any } = {};

  async mounted() {
    this.userInfo = this.$store.state.user.userInfo;
  }

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: '确认信息',
          content: '你确定要提交吗？',
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch('enterapply/close', {
              //   note: this.value,
              stadium_id: this.stadiumId,
              ...values,
            });
            if (res && res.Message && res.Message === 'success') {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }
}
